module.exports = new __parcel__URL__("instantheal.bd4d9f5e.png").toString();